import React, { PureComponent } from 'react';
import NotificationSystem from 'react-notification-system';
import PropTypes from 'prop-types';

export default class NotificationComponent extends PureComponent {
  static propTypes = {
    position: PropTypes.string.isRequired,
    title: PropTypes.string,
    message: PropTypes.string,
    img: PropTypes.string,
    className: PropTypes.string
  };

  constructor(props) {
    super(props);

    this.state = {
      _notificationSystem: null
    };

    this._addNotification = this._addNotification.bind(this);
  }

  // componentDidUpdate(prevProps, prevState) {
  //   if (prevProps.uuid) {
  //     return prevProps.uuid !== this.props.uuid ? this._addNotification() : null;
  //   }
  // }

  _addNotification() {
    this._notificationSystem.addNotification({
      level: (this.props.className ? `${this.props.className}` : 'success'),
      position: `${this.props.position}`,
      children: (
        <div className='notification__content-wrap'>
          {this.props.img ? <img className='notification__img' src={this.props.img} alt='notification-img' /> : ''}
          <div className='notification__content'>
            <h5 className='notification__title bold-text'>{this.props.title}</h5>
            <p className='notification__message'>{this.props.message}</p>
          </div>
        </div>
      )
    });
  }

  componentDidMount() {
    this._notificationSystem = this.refs.notificationSystem;
    this._addNotification()
  }

  render() {
    const style = {
      Dismiss: {
        DefaultStyle: {
          top: '20px',
          right: '20px',
          backgroundColor: 'transparent',
          fontWeight: 'normal',
        }
      },
      Containers: {
        DefaultStyle: {
          maxWidth: '420px',
          width: '100%',
          zIndex: '99'
        },
        tr: {
          top: '60px'
        },
        tl: {
          top: '60px',
          left: '240px'
        },
        bl: {
          left: '240px'
        },
        tc: {
          top: '60px',
          left: '0',
          maxWidth: '100vw',
          width: '100vw',
          padding: '0'
        }
      },
      NotificationItem: {
        DefaultStyle: {
          borderTop: 'none',
          padding: '0',
          width: '100%',
          boxShadow: '0 2px 8px 0 rgba(0, 0, 0, 0.07)',
          borderRadius: '0',
          height: 'auto'
        },
        success: {
          backgroundColor: '#2d9aa6'
        },

        error: {
          backgroundColor: '#f24b59'
        },

        warning: {
          backgroundColor: '#f6da6e'
        },

        info: {
          backgroundColor: '#0f3d59'
        }
      }
    };

    return (
      <div className={this.props.className ? `notification notification--${this.props.className}` :
        'notification notification--basic'}>
        <div>
          {this.props.children}
        </div>
        <NotificationSystem ref='notificationSystem' style={style} />
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Notification.js